interface Breadcrumb {
    label: string;
    href: string;
}

export default function transformBreadcrumb(breadcrumb: string): Breadcrumb[] {
    // Divide la cadena por el separador " / "
    const parts = breadcrumb.split(" / ");

    // Genera el array de objetos con `label` y `href`
    return parts.map((part, index) => ({
        label: part.trim(),
        href: index === parts.length - 1 ? '' : `/${part.trim().toLowerCase().replace(/\s+/g, '-')}`
    }));
}
